import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IHighlightEntity, MapPinItem } from './map/map/map.component';
import { SessionStorage } from 'src/app/shared/functions/SessionStorage';


@Injectable()
export class HybridUiMapService {

    // session caches for items. These allow persisting state between page reloads
    @SessionStorage
    private itemsCache: MapPinItem[];
    @SessionStorage
    private highlightedItemCache: IHighlightEntity;

    // items stream
    public items$: BehaviorSubject<MapPinItem[]>;
    public highlightItem$: BehaviorSubject<IHighlightEntity>;

    public allowBoundingBoxFilter$: BehaviorSubject<boolean>;
    public boundingBox$: BehaviorSubject<string>;


    constructor(
    ) {
        // restore items from cache
        const items = this.itemsCache && this.itemsCache.length > 0 ? this.itemsCache : [];
        const highlightedItem = this.highlightedItemCache ? this.highlightedItemCache : undefined;

        this.items$ = new BehaviorSubject<MapPinItem[]>(items);
        this.highlightItem$ = new BehaviorSubject<IHighlightEntity>(highlightedItem);


        this.allowBoundingBoxFilter$ = new BehaviorSubject<boolean>(false);
        this.boundingBox$ = new BehaviorSubject<string>('');

        // subscribe to changes so that cache can be updated
        this.items$.subscribe(res => {
            // clear highlighted item
            this.highlightItem$.next(undefined);

            // clone items to cache
            const clonedItems = [];
            res.forEach(o => clonedItems.push(Object.assign({}, o))); // make a clone of each object and add them to array
            this.itemsCache = clonedItems;
        });

        this.highlightItem$.subscribe(res => {
            this.highlightedItemCache = res;
        });
    }
}
